// @ts-nocheck

export class MaskIP {
  public insertIconValidate = true;
  public validateAllDigit = false;

  constructor(_view: any, public assets: any) {}

  // public maxLength = 11;

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    return { newValue: value, newCursorPosition: cursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      // case0: 1234 => 123.4
      // case1: 1.2343 => 1.234.3 , 244.2552 => 244.255.2
      // case2: 1.2.3434 => 1.2.343.4 , 244.255.2482 => 244.255.248.2
      // case3: 1.2.343.4455 => 1.2.343.445 , 244.255.248.2344 => 244.255.248.234

      const cases = {
        case0: /^(\d{3})(\d{1})$/,
        case1: /^(\d{1,3})\.(\d{3})(\d{1})$/,
        case2: /^(\d{1,3})\.(\d{1,3})\.(\d{3})(\d{1})$/,
        case3: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{3})(\d{1,3})$/,
      };
      // eslint-disable-next-line no-useless-escape
      const remove = /[^0-9\.]+/g;
      if (value.match(cases.case0)) {
        const formatedValue = value.replace(cases.case0, '$1.$2');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case1)) {
        const formatedValue = value.replace(cases.case1, '$1.$2.$3');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case2)) {
        const formatedValue = value.replace(cases.case2, '$1.$2.$3.$4');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case3)) {
        const formatedValue = value.replace(cases.case3, '$1.$2.$3.$4');

        return { formatedValue, formatedCursorPosition: cursorPosition };
      } else {
        const newFormatedValue = value.replace(remove, '');
        return { formatedValue: newFormatedValue, formatedCursorPosition: cursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    return value.match(/^((1?\d{1,2}|2([0-4]\d|5[0-5]))\.){3}(1?\d{1,2}|2([0-4]\d|5[0-5]))$|^$/);
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['IP']];
  }
}
